import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import { Cell, Column } from 'react-table';

import IndeterminateCheckbox from '../../../components/IndeterminateCheckbox';
import { defaultDateFormat } from '../../../constants/dates';
import { StyledIndicator, StyledIndicatorWrapper, StyledMessageWrapper, StyledNotificationDetails } from './styled';
import { NotificationsTable } from './types';

export const getColumns = (): Column<NotificationsTable>[] => [
  {
    Header: (column): JSX.Element => (
      <IndeterminateCheckbox dataTestid="checkboxForAllNotifications" {...column.getToggleAllRowsSelectedProps?.()} />
    ),
    accessor: 'selected',
    Cell: ({ row }: Cell<NotificationsTable>): JSX.Element => (
      <IndeterminateCheckbox {...row.getToggleRowSelectedProps?.()} />
    ),
    disableSortBy: true,
    width: '5%',
  },
  {
    Header: 'Category',
    id: 'header',
    accessor: 'header',
    Cell: (cell: Cell<NotificationsTable>): JSX.Element => (
      <StyledNotificationDetails data-testid="headerTableCell" $isUnread={!cell.row.original.acked}>
        {cell.row.original.header}
      </StyledNotificationDetails>
    ),
    width: '5%',
  },
  {
    Header: (): JSX.Element => (
      <StyledMessageWrapper>
        <StyledIndicatorWrapper />
        Message
      </StyledMessageWrapper>
    ),
    id: 'message',
    Cell: (cell: Cell<NotificationsTable>): JSX.Element => (
      <StyledMessageWrapper>
        <StyledIndicatorWrapper>
          {!cell.row.original.acked && <StyledIndicator data-testid="indicatorWrapper" />}
        </StyledIndicatorWrapper>
        <StyledNotificationDetails
          data-testid="messageTableCell"
          $isUnread={!cell.row.original.acked}
          dangerouslySetInnerHTML={{
            __html: generateSanitizedHTML(cell.row.original.text || ''),
          }}
        />
      </StyledMessageWrapper>
    ),
    width: '90%',
  },
  {
    Header: 'Date',
    id: 'createdAt',
    accessor: 'createdAt',
    Cell: (cell: Cell<NotificationsTable>): JSX.Element => (
      <StyledNotificationDetails data-testid="createdAtTableCell" $isUnread={!cell.row.original.acked}>
        {dayjs(cell.row.original.createdAt).format(defaultDateFormat) || '-'}
      </StyledNotificationDetails>
    ),
    width: '5%',
  },
];

export const generateSanitizedHTML = (html: string): string => {
  const spacedHtml = html.replace(/<\/?(p|div|br|li|ul|h[1-6])\s*\/?>/g, ' ');
  const sanitized = DOMPurify.sanitize(spacedHtml, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });
  return sanitized.replace(/\s+/g, ' ').trim();
};
